import { copyText } from '@lib/utils/clipboard';
import { Banner } from './Banner';
import { Button } from './Button';
import { Field } from './Field';
import { useToast } from './Toast';

export interface InviteNoticeCopy {
  sent: (to: string, until: string) => string;
  manual: (until: string) => string;
  link: string;
  copy: string;
  copied: string;
  copyFailed: string;
}

/**
 * An operator's invitation: e-mailed (to whom, until when), or, while the server has no SMTP, the one-time link the
 * admin hands over to the person in charge directly.
 */
export function InviteSentNotice({ sentTo, until, manualLink, copy }: { sentTo: string | null; until: string; manualLink?: string; copy: InviteNoticeCopy }) {
  const toast = useToast();
  if (sentTo) {
    return (
      <Banner tone="ok" icon="mail">
        {copy.sent(sentTo, until)}
      </Banner>
    );
  }
  return (
    <div className="form">
      <Banner tone="info" icon="key">
        {copy.manual(until)}
      </Banner>
      {manualLink && (
        <>
          <Field label={copy.link}>{(id) => <input id={id} readOnly className="input-mono" value={manualLink} onFocus={(e) => e.target.select()} />}</Field>
          <Button icon="key" onClick={() => void copyText(manualLink).then((ok) => toast(ok ? copy.copied : copy.copyFailed, !ok))}>
            {copy.copy}
          </Button>
        </>
      )}
    </div>
  );
}
